if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = this.cartObj();
          this.submitButton = this.querySelector('[type="submit"]');
          this.hideErrors = this.dataset.hideErrors === 'true';
        }

        cartObj(){
            return{
                    getSectionsToRender : ()=>{
                        return [
                            {
                              id: 'cart-icon-bubble',
                              parentSelector : '.cart-icon-wrapper',
                              selector: '.cart-icon'
                            }
                          ];
                    },
                    renderContents : (parsedState)=>{
                        this.cart.getSectionsToRender().forEach((section) => {
                        const sectionElement = section.parentSelector
                            ? document.querySelectorAll(section.parentSelector)
                            : document.getElementById(section.id);
                        const replacableHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
                        sectionElement.forEach((el) => {    
                            el.innerHTML = replacableHTML;
                        });
                     })
                    }
                }
        }

        getSectionInnerHTML(html, selector = '.shopify-section') {
            return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
        }

        fetchConfig(type = 'json') {
            return {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
            };
          }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
          this.handleErrorMessage();
  
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('spinner-loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
          const config = this.fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
  
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
  
          fetch(`${theme.routes.cartAdd}`, config)
            .then((response) => response.json())
            .then((response) => {
                console.log(response)
              if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              this.error = false;
              document.dispatchEvent(new Event("cart:build"));
              this.cart.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('spinner-loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
  
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
  
          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }
  